//-----------------------------------
// product-section.js
// @=> theme/section/product-section.liquid
//-----------------------------------

import Vue from 'vue';
import { formatMoney } from '@shopify/theme-currency';
import _assignIn from 'lodash/assignIn';
import { Sections } from '../sections/sections';
import { TimelineMax } from 'gsap';
// import axios from 'axios'
import { store } from '../../vuex/store';
import axios from 'axios'
import { glider } from 'glider-js';
import { sistersize } from '../snippets/sistersize';
import 'scrollmonitor';
import { quickAdd } from '../snippets/quickAdd';
/* global
glider
scrollMonitor
*/

let Product = (function() {
    function Product() {
      product.init();
    }
  
    Product.prototype = _assignIn({}, Product.prototype, {
      onLoad: function() {
        product.onLoad();
      },
      onUnload: function() {
        product.onUnload();
      },
      onSelect: function() {
        product.onSelect();
      },
      onDeselect: function() {
        product.onDeselect();
      }
    });
  
    return Product;
  })();
  
  // Product Module
// ---------------------------------------
export let product = {
    _initialized: false,
    registerSection() {
      if (this._initialized) return;
      this._initialized = true;
      let sections = new Sections();
      sections.register('product-template', Product);
    },
  
    init() {
      
      product.initializeVue();
      product.slideshow();
      // product.relatedProducts();
      product.eventListeners();
      product.mobileSticky();
      product.desktopSticky();
      product.relatedProducts(); 
      quickAdd.init();
      product.sizeChart();
      sistersize.init();
      
      // carousels.categoriesSlider();
  
    },
    // Init Vue
    //-----------------------------------
    initializeVue(state) {
      const sizingVue = new Vue({
        el: '#ProductInfo-vueBra',
        store,
        delimiters: ['${', '}'],
        data: function() {
          return {
            productData: {},
            intialData: {},
            bandSizes: [],
            selectedBand: '',
            cupSizes: [],
            selectedCup: '',
            selectedAlpha: '',
            alphaSizes: [],
            sizes: [],
            variants: [],
            options: [],
            qty: 1,
            maxQty: 10,
            addToBagText: "select your size",
            preorderDate: "",
            is_bra: false,
            // bundle data
            is_diff_size: true,
            same_sizes: [],
            diff_sizes: [],
            diff_types: [],
            the_sizes: [],
            grouped_variants:[],
            ungrouped_variants: [],
            tops_group: [ 'chemise','cami'],
            tops: [],
            bottoms_group: ['hi leg','bikini','hipster','thong','cheeky','boyshort','tanga','shorty','hikini'],
            bottoms: [],
            bras_group: ['t-shirt','push up','contour','underwire','balconette','strapless','plunge'],
            bras: [],
            bralettes_group: [ 'bralette', 'wire free' ],
            bralettes: [],
            misc_group: ['accessories', 'bodysuit', 'garter belts'],
            bodysuits: [],
            bodysuits_group: ['bodysuit' ],
            kimonos: [],
            kiminos_group: ['lounge wrap'],
            misc: [],
            product_id: '',
            lowestAvailInv: '10000',
            loadComplete: false,
            qty_to_add: 1,
            productType: '',
            lowInStockText: '',
            stickyBtnText: 'select your size', 
            alphaSizeConverterInput: '',
            alphaSizeConverterResult:'',
            educationalSize: null,
            educationalCopy: '',
            showSignupForm: false,
            showSignupSuccess: false,
            alphaSizeConverterObj: {
              "bralettes" : {
                XS : ["30A", "30B", "32A", "32B"],
                S : ["32C", "32D", "34A", "34B"],
                M : ["32DD","32E", "34C", "34D", "34DD", "34E", "36A", "36B"],
                L : ["36C", "36D", "36DD", "36E", "38A", "38B", "38C", "38D"]         
              },
              "busty_bralettes" : {
                1 : ["32DD", "32E", "32DDD", "32F", "34D", "34DD", "34E"],
                2 : ["34DDD", "34F", "36D", "36DD", "36E", "36DDD", "36F"],
                3 : ["38D", "38DD", "38E", "38DDD", "38F", "40D", "40DD", "40E"],
                4 : ["40DDD","40F", "40G", "42DD", "42E", "42DDD", "42F"]
              }
            }
          };
        },
        beforeCreate: function(){
          console.log('beforeCreate')
        },
        created: function(){
            console.log('created')
            this.getSizes();
        }, 
        mounted() {
          console.log('mounted')
          this.getAllProductData();
        },

        methods: {
          getSizes: function(){
            let vm = this;
            let size_range = window.LivelyPDP.sizes;
            let band_sizes = [];
            let cup_sizes = [];
            console.log('SIZES')
            vm.intialData = window.LivelyPDP;
            vm.is_bra = window.LivelyPDP.is_bra;
            vm.productType = window.LivelyPDP.product_type;
            if(window.LivelyPDP.is_bra === true){
              let size_range_mod = size_range.map(function(size){
                let size_split = size.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
                band_sizes.push(size_split[0])
                cup_sizes.push(size_split[1])
                return {band: size_split[0], cup: size_split[1] }
              })
  
              let band_array = [...new Set(band_sizes)];
              let cup_array = [...new Set(cup_sizes)];
              vm.bandSizes = band_array
              vm.cupSizes = cup_array.sort();
              

              console.log(size_range_mod)

              console.log(band_array)
              console.log(cup_array)
            }else{
              vm.alphaSizes = size_range
            }
            this.loadComplete = true;
          },
          alphaSizeConverter: function(e){
            e.preventDefault()
            this.alphaSizeConverterResult = ''
            document.getElementById('AlphaSizeConverter-button').classList.add('AlphaSizeConverter-btn-grey') 
            this.alphaSizeConverterInput = this.alphaSizeConverterInput.toUpperCase()
            const alphaSizes = this.alphaSizeConverterObj.bralettes
            const numberSizes = this.alphaSizeConverterObj.busty_bralettes
            const productSizes = window.LivelyPDP.is_number_sizes ? numberSizes : alphaSizes
            const otherSizes = window.LivelyPDP.is_number_sizes ? alphaSizes : numberSizes
            const input = this.alphaSizeConverterInput

            //Search for entered size in the respective data structure 
            const result = getAlphaSize(productSizes)
            this.alphaSizeConverterResult = result ? "Size " + result : "N/A"

            //autoselect size if available
            if(this.alphaSizes.includes(result)){
              this.selectedAlpha = result
            } else {
              this.selectedAlpha = ''
            }

            //Search for selected size in the other data structure for possible educational moment
            this.educationalSize = getAlphaSize(otherSizes)

            //set educational copy
            if(this.alphaSizeConverterResult === "N/A"){
              this.educationalCopy = "The Good News?"
              //show waitlist form
              if(!this.educationalSize){
                this.showSignupForm = true
              } else {
                this.showSignupForm = false
              }
            } else {
              this.showSignupForm = false
              this.educationalCopy = window.LivelyPDP.educational_copy
            }

            function getAlphaSize(sizesArray) {
              for(const alphaSize in sizesArray){
                if(sizesArray[alphaSize].includes(input)){
                  return alphaSize
                }
              }
              return null
            }
          },
          alphaSizeConverterKeyup: function(e){
            if(e.key !== "Enter"){
              e.target.value = e.target.value.toUpperCase().replace(' ', '');
              document.getElementById('AlphaSizeConverter-button').classList.remove('AlphaSizeConverter-btn-grey')
              this.showSignupForm = false
              if(this.alphaSizeConverterInput === ''){
                this.alphaSizeConverterResult = ''
              } else {
                this.alphaSizeConverterResult = ' '
                this.educationalSize = null
              }
            }
          },
          handleAlphaSizeKlaviyoFormSubmit: async function(e){
            e.preventDefault()
            const input = document.getElementById("AlphasSizeSignup-email")
            const email = input.value
            const public_key = 'V2aAAQ'
            const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${public_key}`
            const size = this.alphaSizeConverterInput
            const product = this.productData.current_title
            const body = JSON.stringify({
              "data": {
                "type": "subscription",
                "attributes": {
                  "profile": {
                    "data": {
                      "type": "profile",
                      "attributes": {
                        "properties": {
                          "requested_size": size,
                          "product": product
                        },
                        "email": email
                      }
                    }
                  }
                },
                "relationships": {
                  "list": {
                    "data": {
                      "type": "list",
                      "id": "W8kANT"
                    }
                  }
                }
              }
            })
            try {
              const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", "revision": "2023-07-15" },
                body : body,
                redirect: 'follow',
              })
              if(response.ok){
                this.showSignupForm = false
                this.showSignupSuccess = true
                setTimeout(() => {
                  this.showSignupSuccess = false
                }, 3000)
              }
            } catch (err){
              console.log(err.message)
              this.showSignupError = true
            }
          },
          getAllProductData: function(){
            let vm = this;
            console.log('get all variant data')
            const theHandle = vm.intialData.handle

            if(!vm.intialData.is_bundle){
              // if it's not a bundle
              let the_url = window.Shopify.routes.root + 'products/'+theHandle+'?view=pdpjson'
              axios.get(the_url)
                .then(function (response) {
                  console.log(response.data);
                  // ata.json(JSON.stringify(data))
                  vm.productData = response.data;
                  vm.variants = response.data.variants;
                  if( !vm.is_bra ){
                    // loop over variants and add sold out class to the ones who are 
                    let sizesArray = vm.intialData.sizes
                    vm.autoselectSize()
                    vm.alphaSizes.forEach(function(size){
                      let theIndex = sizesArray.indexOf(size);
                      console.log(theIndex)
                      let soldoutSize = document.querySelector('input[data-size="'+ size+'"]')
                      if( theIndex < 0 ){
                        // it's sold out 
                        console.log(soldoutSize)
                        soldoutSize.classList.add("is-soldout")
                        // soldoutSize.setAttribute('disabled', '');
                        // vm.$refs[size].classList.add("is-soldout")
                      }else{
                        // find its variant 
                        let variant = vm.variants[theIndex]
                        if (
                          variant.inventory_management == 'shopify' &&
                          variant.inventory_policy == 'continue' &&
                          variant.inventory_quantity <= 0
                        ) {
                          console.log('preorder!! ' + size);
                        }else if(variant.inventory_quantity <= 0){
                          console.log('sold out!  ' + size);
                          soldoutSize.classList.add("is-soldout")
                          // soldoutSize.setAttribute('disabled', '');
                        }else{
                          console.log('not preorder!! ' + size);
                        }

                      }
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            }else{
              // else its a bundle 
              console.log('is a bundle');
              let the_url = window.Shopify.routes.root + 'products/'+theHandle+'?view=bundlejson'
              axios.get(the_url)
              .then(function (response) {
                console.log(response.data);
                vm.productData = response.data;
                vm.is_diff_size = response.data.different_sizes
                vm.product_id = response.data.current_id
                vm.qty_to_add = parseInt(response.data.single_prod_qty)  
                if (response.data.different_sizes){
                  vm.addToBagText = 'select your sizes'
                }
                vm.autoselectSize()
                vm.getBundleSizes();
                vm.buildBundleSizes();
                // are any sold out? 
                const soldOutBundles = vm.grouped_variants.filter(variant => variant.soldout === true);
                console.log('soldOutBundles')
                console.log(soldOutBundles);
                if(soldOutBundles.length > 0){
                  soldOutBundles.forEach(function(variant){
                    let soldoutSize = document.querySelector('input[data-size="'+variant.size+'"]')
                    soldoutSize.classList.add("is-soldout")
                    // soldoutSize.setAttribute('disabled', '');
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
              });
            } 
          },
          autoselectSize: function(){
            let vm = this
            //if there is only one size, autoselect it
            if(vm.alphaSizes.length == 1){
              vm.selectedAlpha = vm.alphaSizes[0]
            }
          },
          addToBag: function(){
            let is_kit = window.LivelyKits.is_kit;
            console.log('adding...')
            let vm = this;
            vm.addToBagText = 'adding...'
            // set the qty, make sure it's not over the max
            
            if (vm.qty > vm.maxQty){
              vm.qty = vm.maxQty
            }
            let theQty = vm.qty;
            
            let payload;

            if(is_kit){
              payload = {
                id: this.selectedId,
                props: { quantity: theQty, properties: window.LivelyKits.kit_items_props },
              };
              console.log(window.LivelyKits.kit_items_props)
            }else{
              payload = {id: this.selectedId, props: { quantity: theQty} }
            }
            console.log('PAYLOAAAAAD')
            console.log(payload)
           

            store.dispatch('cart/addItem', payload).then(function(){
              // $addToCart.text( 'ADDED!');
              if ( !$('#shopify-section-cart').hasClass('is-open')  ){
                //disable background scroll on mobile when opening cart
                document.body.classList.add('noscroll-mobile')
                $('#shopify-section-cart').delay(400).queue(function(next){
                  $(this).addClass('is-open'); 
                  // $('#cartDrawerNew').addClass('is-open'); 
                  next();
                });
                vm.addToBagText = 'add to cart'
                 // Trigger all pixel events
            

                //GA4
                console.log("ADDED TO BAG GA4")
                let title = vm.productData.current_title
                let slicePosition = title.indexOf(':')
                let productTitle = title.slice(0, slicePosition)
                let productColor = title.slice(slicePosition + 2)
  
                gtag('event', 'added_prod', {
                  'product': productTitle,
                  'variant': vm.selectedSize,
                  'color' : productColor,
                  'type': 'PDP',
                  'bundle': false
                })

                // setTimeout(function(){ 
                //   $('#cartDrawerNew').addClass('is-open'); 
              
                //   },350);
                
              }
            });

            // let cartPromise = $.post('/cart/add.js', {
            //   items: [payload]
            // })
            // .done(function(data){
            //   console.log( "done!" );
            //   this.$store.dispatch('cart/updateCart');
            //   // Now open the cart
            //   const cart = document.getElementById('cartDrawerNew');
            //   cart.classList.add('is-open');
              
            //   setTimeout(() => {
            //     vm.addToBagText = 'add to bag'
            //   }, 1000)
            // })
            // .fail(function() {
            //   console.log( "error" );

            // })
            // .always(function() {
            //   console.log( "finished" );
            // });
             
            
          },
          addBundleToBag: function(){
            let vm = this;
            vm.addToBagText = 'adding...'

            // check the current selected size
            let selected_bundle_size = this.selectedAlpha
            let all_variants = this.grouped_variants
            let the_ids =[]
            const the_qty = this.qty_to_add;
            let just_ids = []
            let dupe_id_qty = {};
            let user_qty = this.qty;

               // Filter through the current sizes, grab their IDs 
             all_variants.filter(function(size){
              // console.log('current size: '+ size.size)
                if (size.size === selected_bundle_size){
                  // console.log('matching')
                  just_ids = size.variants.map(function(variant){
                    // console.log('variant.id')
                    // console.log(variant.id)
                    // return variant.id
                    return variant.id
                  })
                  return just_ids
                }
            });

            console.log('just_ids')
            console.log(just_ids)

            // Grab the num of times we have each variant ID 
            for (const num of just_ids) {
              dupe_id_qty[num] = dupe_id_qty[num] ? dupe_id_qty[num] + 1 : 1;
            }
            console.log('dupe_id_qty');
            console.log(dupe_id_qty)

            the_ids = just_ids.map(function(variant){
              let the_final_qty = the_qty * dupe_id_qty[variant] * user_qty
              return {id: variant, quantity:the_final_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }
            })
            console.log('the final IDs')
            console.log(the_ids)

            // If we have an additonal one sized item (think, cool things) in this bundle 
            if (this.productData.add_os_item){
              // grab the one sized item, jam it into the IDs rigth away 
              this.productData.one_size.forEach(function(product){
                console.log(product.variants[0].id)
                // the_ids.push(product.variants[0].id) 
                the_ids.push({id: product.variants[0].id, quantity:the_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }) 
              });
              // the_ids.push()
            }
            let final_unique_ids = []
            final_unique_ids =  the_ids.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
            console.log('final_ids');
            console.log(final_unique_ids);

            // Add to cart via cart API
            let the_url = window.Shopify.routes.root + 'cart/add.js';
            let cartPromise = $.post(the_url, {
              "items": final_unique_ids
            })
            .done(function(data) {
              console.log( "second success" );
              console.log(data)
              vm.addToBagText = 'added!'
              // Trigger an update 
              store.dispatch('cart/updateCart');
              // Now open the cart
              // const cart = document.getElementById('cartDrawerNew');
              const cart = document.getElementById('shopify-section-cart');
              cart.classList.add('is-open');
             
              //GA4 Bundles
              vm.productData.bundle_same.forEach(item => {
                let title = item.title.slice(0, item.title.indexOf(':'))
                let color = item.title.slice(item.title.indexOf(':') + 2)
                gtag('event', 'added_prod', {
                    'product': title,
                    'variant': vm.selected_size,
                    'color' : color,
                    'type': 'PDP',
                    'Bundle': true
                })
            })

              // change the add to cart button text back 
              setTimeout(function(){
                vm.addToBagText = 'add to cart'
              }, 1000);
            })
            .fail(function() {
              console.log( "error" );
            })
            .always(function() {
              console.log( "finished" );
            });

          },
          addBraBundle: function(){
            let vm = this;
            vm.addToBagText = 'adding...'

            // check the current selected size
            let selected_bundle_size = this.selectedSize
            let all_variants = this.grouped_variants
            let the_ids =[]
            const the_qty = this.qty_to_add;
            let just_ids = []
            let dupe_id_qty = {};
            let user_qty = this.qty;

               // Filter through the current sizes, grab their IDs 
             all_variants.filter(function(size){
              // console.log('current size: '+ size.size)
                if (size.size === selected_bundle_size){
                  // console.log('matching')
                  just_ids = size.variants.map(function(variant){
                    // console.log('variant.id')
                    // console.log(variant.id)
                    // return variant.id
                    return variant.id
                  })
                  return just_ids
                }
            });

            console.log('just_ids')
            console.log(just_ids)

            // Grab the num of times we have each variant ID 
            for (const num of just_ids) {
              dupe_id_qty[num] = dupe_id_qty[num] ? dupe_id_qty[num] + 1 : 1;
            }
            console.log('dupe_id_qty');
            console.log(dupe_id_qty)

            the_ids = just_ids.map(function(variant){
              let the_final_qty = the_qty * dupe_id_qty[variant] * user_qty
              return {id: variant, quantity:the_final_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }
            })
            console.log('the final IDs')
            console.log(the_ids)

            // If we have an additonal one sized item (think, cool things) in this bundle 
            if (this.productData.add_os_item){
              // grab the one sized item, jam it into the IDs rigth away 
              this.productData.one_size.forEach(function(product){
                console.log(product.variants[0].id)
                // the_ids.push(product.variants[0].id) 
                the_ids.push({id: product.variants[0].id, quantity:the_qty, properties: { "_bundle": true, "_bundleTitle": vm.productData.current_title } }) 
              });
              // the_ids.push()
            }
            let final_unique_ids = []
            final_unique_ids =  the_ids.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
            console.log('final_ids');
            console.log(final_unique_ids);

            // Add to cart via cart API
            let the_url = window.Shopify.routes.root + 'cart/add.js';
            let cartPromise = $.post(the_url, {
              "items": final_unique_ids
            })
            .done(function(data) {
              console.log( "second success" );
              console.log(data)
              vm.addToBagText = 'added!'
              // Trigger an update 
              store.dispatch('cart/updateCart');
              // Now open the cart
              // const cart = document.getElementById('cartDrawerNew');
              const cart = document.getElementById('shopify-section-cart');
              cart.classList.add('is-open');
            
              //GA4 
              vm.productData.bundle_same.forEach(item => {
                let title = item.title.slice(0, item.title.indexOf(':'))
                let color = item.title.slice(item.title.indexOf(':') + 2)
                gtag('event', 'added_prod', {
                    'product': title,
                    'variant': vm.selected_size,
                    'color' : color,
                    'type': 'PDP',
                    'Bundle': true
                })
            })

              // change the add to cart button text back 
              setTimeout(function(){
                vm.addToBagText = 'add to cart'
              }, 1000);
            })
            .fail(function() {
              console.log( "error" );
            })
            .always(function() {
              console.log( "finished" );
            });

          },
          clickedBand: function(){
            let vm = this;
            console.log('CLICKED BAND');
            // if you've selected a band size 
            // combine them with cup sizes
            if( vm.selectedBand != '' ){
              console.log(vm.selectedBand)
              let theSizes = vm.cupSizes.map(function(cup){
                return vm.selectedBand + cup
              });
  
              console.log(theSizes)
              let sizesArray = vm.intialData.sizes
              // look at all these sizes and see if they're in stock 
              setTimeout(() => {
                console.log("Delayed for 1 second.");
                theSizes.forEach(function(size){
                  // get the index of the size
                  console.log('size')
                  console.log(size)
                  let theIndex = sizesArray.indexOf(size);
                  console.log('theIndex')
                  console.log(theIndex)
                  let soldoutSize = document.querySelector('input[data-size="'+ size+'"]')

                    if( theIndex < 0 ){
                      // it's sold out 
                      console.log(soldoutSize)
                      soldoutSize.classList.add("is-soldout")
                      // soldoutSize.setAttribute('disabled', '');
                      // vm.$refs[size].classList.add("is-soldout")
                    }else{
                      // find its variant 
                      let variant = {}
                      if (!vm.intialData.is_bundle ){
                        console.log('not a bundle')
                         variant = vm.variants[theIndex]
                      }else{
                        console.log('is a bundle')
                         variant = vm.grouped_variants[theIndex]
                         console.log(variant);
                         console.log( variant.inventory_management  )
                         console.log( variant.inventory_policy  )
                         console.log( variant.inventory_quantity  )
                      }
                      
                      if (
                        variant.inventory_management == 'shopify' &&
                        variant.inventory_policy == 'continue' &&
                        variant.inventory_quantity <= 0
                      ) {
                        console.log('preorder!! ' + size);
                      }else if(variant.inventory_quantity <= 0){
                        console.log('sold out!  ' + size);
                        soldoutSize.classList.add("is-soldout")
                        // soldoutSize.setAttribute('disabled', '');
                      }else{
                        console.log('not preorder!! ' + size);
                      }

                    }
                
                });
              }, 25)
              
  
            }
            
          },
          clickedAlpha: function(){
            let vm = this;
          },
          getBundleSizes: function(){
            let vm = this;
            if(this.is_diff_size == false){
              // if we have the same size products, life is a little easier
              // Grab the first product and push the sizes into data land
              let size_range = this.productData.bundle_same[0].variants.map(function(variant){
                console.log(variant.option1);
                return variant.option1
              })
              // Save your current size range
              this.same_sizes = size_range

              // push all variants to ungrouped 
              this.productData.bundle_same.forEach(function(product){
                product.variants.forEach(function(variant){
                  vm.ungrouped_variants.push(variant)
                })
              });
            }
          },
          buildBundleSizes: function(){
            let vm = this;
            const products_count = this.productData.bundle_same.length;
            console.log('SIZESSSSS')
            console.log(products_count)
            if(this.is_diff_size == false){
              const the_sizes = this.same_sizes
              // const is_same_prod = this.productData.single_prod
              const same_prod_qty = this.qty_to_add
              console.log('IS SAME SIZES QTY')
              console.log(same_prod_qty)
              
              let the_size_arr = the_sizes.map(function(size){
                let the_current_size = size;
                console.log('size for eacn')
                console.log(size)
                let the_matching_variants = vm.ungrouped_variants.filter(function(variant){
                  // if opt1 = current size, add releveant info as an obj to the array
                  if (variant.option1 === the_current_size ){
                    return variant
                  }else{
                    return false
                  }
                }).map(function(variant){
                  console.log('map');
                  return { "id": variant.id, "qty": variant.qty, "inventory_quantity": variant.qty }
                });
                    
                let is_sold_out = the_matching_variants.every(function (number){
                  return number.qty >= same_prod_qty;
                });

                let variants_count = (products_count === the_matching_variants.length)?true:false;
                // console.log('VARIANTS COUNT')
                // console.log(variants_count)
                // console.log('instock: '+is_sold_out);
                let the_conditions_array = [!is_sold_out, variants_count]
                let the_conditions = the_conditions_array.every(Boolean)
                // console.log('the_matching_variants');
                // console.log(the_matching_variants)
                const lowestInv = the_matching_variants.reduce((previous, current) => {
                  return current.inventory_quantity < previous.inventory_quantity ? current : previous;
                });
                return {"size": size, "soldout": the_conditions, "inventory_policy": "deny", "inventory_management": "shopify", "inventory_quantity": lowestInv.inventory_quantity, "variants": the_matching_variants}
              });

              console.log('the_size_arr');
              console.log(the_size_arr);

              console.log('set group variants');
              this.grouped_variants = the_size_arr;
              this.variants = the_size_arr;
            }
          },
          addToBagSticky: function(){
            if(this.addToBagText === 'add to cart' || this.addToBagText === 'preorder' ){
               $('#AddToBag').click();
               console.log('add to bag')
            }else if( this.addToBagText === 'sold out'){
              $('#BIS_trigger').click();
            }else{
              console.log('scroll')
              $('html, body').animate({
                scrollTop: $('#ProductInfo-sizing').offset().top - 150 //#DIV_ID is an example. Use the id of your destination on the page
              }, 'fast');
              
            }
          }
        },
        computed: {
          selectedSize: function(){
            let the_size =''
            let vm = this;
            if (vm.selectedBand != '' && vm.selectedCup != '' && vm.is_bra === true){
              the_size = this.selectedBand+this.selectedCup
            }else if( vm.selectedAlpha != '' && !vm.is_bra ){
              the_size = vm.selectedAlpha
            }
            return the_size 
          },
          selectedId: function(){
            let the_id = 0;
            if (this.selectedSize != '' && !this.intialData.is_bundle){
                let theIndex = this.intialData.sizes.indexOf(this.selectedSize);
                if(theIndex < 0){
                  the_id = 0;
                }else{
                  let variant = this.variants[theIndex]
                  the_id = variant.id;
                }

              console.log(the_id);
            }
            return parseInt(the_id)
          }
        },
        watch: {
          selectedSize: function(size){
            let vm = this;
            console.log('the size is...')
            console.log(size)
            let sizesArray = vm.intialData.sizes
            let theIndex = sizesArray.indexOf(size);
            let variant = vm.variants[theIndex]

            
            if(!vm.intialData.is_bundle){
              console.log(variant)
              if( theIndex < 0 ){
                // it's sold out 
                setTimeout(() => {
                  let soldoutSize = document.querySelector('input[data-size="'+ size+'"]')
                  console.log(soldoutSize)
                  soldoutSize.classList.add("is-soldout")
                  vm.addToBagText = 'sold out'
                  vm.stickyBtnText = 'notify me when available'
                },25)
                
                // soldoutSize.setAttribute('disabled', '');
                // vm.$refs[size].classList.add("is-soldout")
              }else{
                if (
                  variant.inventory_management == 'shopify' &&
                  variant.inventory_policy == 'continue' &&
                  variant.inventory_quantity <= 0
                ) {
                  // If we're in america, preorder it up. If not, make the variant sold out 
                  if (window.Shopify.routes.root === '/'){
                    console.log('preorder!! ' + size);
                    vm.addToBagText = 'preorder'
                    vm.stickyBtnText = 'preorder'
                    vm.preorderDate = variant.preorder_date;
                    vm.maxQty = 10;
                  }else{
                    console.log('fake sold out for preorder!  ' + size);
                    vm.preorderDate = '';
                    vm.addToBagText = 'sold out'
                    vm.stickyBtnText = 'notify me when available'
                    vm.maxQty = 0;
                  }
                  
                
                }else if(variant.inventory_quantity <= 0){
                  console.log('sold out!  ' + size);
                  vm.preorderDate = '';
                  vm.addToBagText = 'sold out'
                  vm.stickyBtnText = 'notify me when available'
                  vm.maxQty = 0;
              
                }else{
                  console.log('not preorder!! ' + size);
                  vm.addToBagText = 'add to cart'
                  vm.stickyBtnText = 'add to cart'
                  vm.preorderDate = '';
                  if ( variant.inventory_quantity < 30 ){
                    vm.maxQty = variant.inventory_quantity
                  }else{
                    vm.maxQty = variant.inventory_quantity - 20
                  }
                 
                }
              }
            }else{
              if(variant.inventory_quantity <= 0){
                console.log('sold out!  ' + size);
                vm.preorderDate = '';
                vm.addToBagText = 'sold out'
                vm.stickyBtnText = 'sold out'
                vm.maxQty = 0;
              }else{
                vm.addToBagText = 'add to cart'
                vm.stickyBtnText = 'add to cart'
              }
              
            }

            // low in stock 
            if (variant.inventory_quantity > 5 && variant.inventory_quantity <= 10 ){
              let thePaddedInv = variant.inventory_quantity - 5;
              vm.lowInStockText = `only ${thePaddedInv} left`
            }else if (variant.inventory_quantity > 3 && variant.inventory_quantity <= 5 ){
              let thePaddedInv = 3;
              vm.lowInStockText = `only ${thePaddedInv} left`
            }else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 3 ){
              vm.lowInStockText = 'only 1 left'
            }else{
              vm.lowInStockText = ''
            }
         
          },
          qty: function(value){
            if(value <= 0){
              this.qty = 0;
            }else if(this.qty > this.maxQty){
              this.qty = this.maxQty;
            }
          }
        }

      })
    },
    slideshow(){

      // Show slider
      document.querySelector('.main-glider').addEventListener('glider-loaded', function(event){
        $('.ProductImages-slider').css('opacity', '1');
        $('.ProductImagesSection').removeClass('is-loading');
      });
      
      let sizeSwap = false;
      let sizeImgs = []
      let originalImgs = []
      let sizesSwaped = false;
      if (window.LivelySizeSwap.size_images.length > 0){
        console.log('we have a size swap');
        sizeSwap = true;
        originalImgs = window.LivelySizeSwap.original_images
        sizeImgs = window.LivelySizeSwap.size_images
        console.log('originalImgs')
        console.log(originalImgs)
        console.log('sizeImgs')
        console.log(sizeImgs)
      }
      
     // init main images 
      let glider = new Glider(document.querySelector('.main-glider'), {
        slidesToShow: 1,
        draggable: true,
        dots: '#ProductImages-dots'
      });

      let theSliderHeight = $('.ProductImagesSection').height;

      $('.ProductImages-select').on('change', function(event){

        let selectedSize = '_' + event.target.value + '_'
        // fetch the images, replace the slider with the images 
        // remove the current images
        $('.ProductImagesSection').height(theSliderHeight)
        $('.glider-slide').remove();
        
        // add them back in 
        if(event.target.value === 'original_images') { 
          originalImgs.forEach((sizeImg) => { //add back the original images
            let img = document.createElement('img')
            img.src = sizeImg
            glider.addItem(img);
          })
        } else {
          sizeImgs.forEach((sizeImg) => { //add in size labeled images and product flats
            if (sizeImg.indexOf(selectedSize) > -1 || sizeImg.includes('product_flat')){
              let img = document.createElement('img')
              img.src = sizeImg
              glider.addItem(img);
            } 
          })
        }

        $('.ProductImagesSection').height('auto');
      
        gtag('event', 'image_size_swap', {
          'product_handle': window.LivelyPDP.handle,
          'selected_size': selectedSize.replaceAll('_', '')
        });
      });
    },
    eventListeners(){

      $('.ProductFeatures-toggle').click(function(){
        
        if(!$(this)[0].classList.contains('ProductFeatures-toggle-active')){
          $('#ProductFeatures-fit, #ProductFeatures-features').toggleClass('ProductFeatures-hide')
        }
        $('.ProductFeatures-toggle-active').removeClass('ProductFeatures-toggle-active')
        $(this).addClass('ProductFeatures-toggle-active')
        
      })

      $('.ProductDescList-trigger').click(function(){
        if( $(this).hasClass('show') ){
            $(this).siblings('.ProductDescList-copy').removeClass('show');
            $(this).removeClass('show');
        }else{
            $(this).addClass('show');
            $(this).siblings('.ProductDescList-copy').addClass('show');
        }
      
        gtag('event', 'pdp_copy_click', {
          'product_handle': window.LivelyPDP.handle,
          'section': $(this).text(),
          'product': window.LivelyPDP.title
        });
       });

       $('.ProductHeader-stamped').click(function(){
          $('html, body').animate({
            scrollTop: $('#ProductReviews').offset().top - 150 
           }, 'fast');
          

          gtag('event', 'pdp_reviews_click', {
            'product_handle': window.LivelyPDP.handle,
            'product': window.LivelyPDP.title
          });
        });
    },
    sizeChart() {
      const $sizeChartBtn = $('.js-ProductInfo-sizeGuide');
      const $sizeChartContainer = $('.js-size-overlay');
      const $sizeChartClose = $('.js-SizeChart-close');

      // //Show Zoom Animation
      const sizeAnim = new TimelineMax({ paused: true, smoothChildTiming: true });
      sizeAnim.set($sizeChartContainer, { opacity: 0 });
      // sizeAnim.to( 'body', 0, {css:{className:'-=u-noScroll'}} );
      sizeAnim.to($sizeChartContainer, 0, { css: { className: 'Overlay Overlay--size js-size-overlay' } });
      sizeAnim.to($sizeChartContainer, 0, { clearProps: 'display' });
      sizeAnim.to($sizeChartContainer, 0.3, { autoAlpha: 1, display: 'block' });
      // sizeAnim.to( 'body', 0, {css:{className:'+=u-noScroll'}} );
      sizeAnim.to($sizeChartContainer, 0, { css: { className: 'Overlay Overlay--size js-size-overlay u-scroll' } });
  
      // Work at any size window but not on touch devices in favor of pinch to zoom
  
      $sizeChartBtn.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // let theType = $(this).attr('data-type')
        // $('.SizeChart-wrap').each(function(){
        //   if( !$(this).attr('id', theType ) ){
        //     $(this).remove();
        //   }
        // });
        // if ( $(window).width() > 1024 ) {
        openSize();
        // }
      });
  
      $sizeChartClose.on('click', function() {
        closeSize();
      });
  
      document.onkeydown = function(evt) {
        evt = evt || window.event;
        let isEscape = false;
        if ('key' in evt) {
          isEscape = evt.key == 'Escape';
        } else {
          isEscape = evt.keyCode == 27;
        }
        if (isEscape) {
          closeSize();
        }
      };
  
      function openSize() {
        // progress.start();
        $sizeChartContainer.attr('aria-hidden', false);
        $sizeChartContainer.attr('aria-modal', true);
        $sizeChartContainer.attr('aria-label', 'Find your size');
        $('.HeaderWrapper').attr('aria-hidden', true);
        $('#shopify-section-product-section').attr('aria-hidden', true).hide();
        $('#ProductReviews').attr('aria-hidden', true).hide();
 
        // shopify-section-product-section
        // HeaderWrapper
        // sizeAnim.set( $sizeChartContainer, {scrollTo: 0} );
  
        $('html, body').animate({ scrollTop: 0 });
        // document.querySelector('.NewSizeChart-title').focus();
        sizeAnim.play();

        gtag('event', 'opened_size_chart', {
          'product_handle': window.LivelyPDP.handle,
          'product': window.LivelyPDP.title
        });

        
        
  
        // console.log('opening size chart');
  
        // Close when click outside zoom
        // $zoomContainer.on('click', function(e) {
        //   if ( !$zoomImage.is(e.target) && $zoomContainer.has(e.target).length === 0 ) {
        //     closeZoom();
        //   }
        // });
      }
  
      function closeSize() {
        $sizeChartContainer.attr('aria-hidden', true);
        sizeAnim.reverse();
        $('#shopify-section-product-section').attr('aria-hidden', false).show();
        $('#ProductReviews').attr('aria-hidden', false).show();
        // console.log('closing sizechart');
        // clearTimeout(timerHack);
      }
    },
    desktopSticky(){
      let $element = $('.ProductImagesSection');
      let watcher = scrollMonitor.create($element, {top: 200});
      watcher.lock();
      console.log('locked' + watcher.top);
      watcher.partiallyExitViewport(function() {
        $element.addClass('is-scrolled');
        $('.ProductSection').addClass('is-scrolled');
        console.log('top exit' + watcher.top);
        console.log('bottom exit' + watcher.bottom);
        console.log('offsets ' + watcher.offsets);

        // $('.CollectionGridProd').css('padding-top', '112px');
      });
      watcher.enterViewport(function() {
        $element.removeClass('is-scrolled');
        $('.ProductSection').removeClass('is-scrolled');
        console.log('top enter' + watcher.top);
        console.log('bottom enter' + watcher.bottom);

        // $('.CollectionGridProd').css('padding-top', '0');
      });
    },
    mobileSticky(){
      let $mobileEl = $('.js-GTM_addtocart');
      let mobileWatcher = scrollMonitor.create($mobileEl);
      mobileWatcher.lock();
      console.log('locked' + mobileWatcher.top);
      mobileWatcher.partiallyExitViewport(function() {
        if(mobileWatcher.isAboveViewport){
          $('.ProductSticky').addClass('is-scrolled');
        }
        
        console.log('sticky top EXIT' + mobileWatcher.top);
        console.log('sticky bottom EXIT' + mobileWatcher.bottom);
        console.log('EXIT is above?')
        console.log(mobileWatcher.isAboveViewport)
        console.log('EXIT is below?')
        console.log(mobileWatcher.isBelowViewport)

      });
      mobileWatcher.enterViewport(function() {
        $('.ProductSticky').removeClass('is-scrolled');
        console.log('sticky top ENTER' + mobileWatcher.top);
        console.log('sticky bottom ENTER' + mobileWatcher.bottom);
        console.log('ENTER is above?')
        console.log(mobileWatcher.isAboveViewport)
        console.log('ENTER is below?')
        console.log(mobileWatcher.isBelowViewport)
      }); 
    },
    relatedProducts(){
      console.log('RELATEDDDD')
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(productRecommendationsSection);
        const url = productRecommendationsSection.dataset.url;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              
              // Reinitialize quickAdd functionality for dynamically loaded products
              quickAdd.init();
            }
          })
          .catch(e => {
            console.error(e);
          });
      };
      const productRecommendationsSection = document.querySelector('.product-recommendations');
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      observer.observe(productRecommendationsSection);
      console.log(productRecommendationsSection);
    },

    // Shopify Theme Editor
    //-----------------------------------
    onLoad() {
      // console.log( 'products section loaded' );
    },
  
    onUnload() {
      // console.log( 'products section un-loaded' );
    },
  
    onSelect() {
      // console.log( 'products section selected' );
    },
  
    onDeselect() {
      // console.log( 'products section deselected' );
    }
  };
  